import React, { Component } from "react";
export class MpaArrowedListHorizontal extends Component {
  render() {
    const { value, values } = this.props;
    return (
      <div
        className="horizontal-arrowed-list-container"
        style={{ color: this.props.assignedcolor }}
      >
        <div
          className="arrow-left"
          style={{ visibility: checkLow(value, values) }}
        >
          &larr;
        </div>
        <div className="arrowed-list-item">{value}</div>
        <div
          className="arrow-right"
          style={{ visibility: checkHigh(value, values) }}
        >
          &rarr;
        </div>
      </div>
    );
  }
}

export class MpaArrowedListVertical extends Component {
  constructor() {
    super();
    this.state = {
      arrowHigh: true,
      arrowLow: true
    };
  }
  render() {
    const { value, values } = this.props;
    return (
      <div
        className="vertical-arrowed-list-container"
        style={{ color: this.props.assignedcolor }}
      >
        <div
          className="arrow-up"
          style={{ visibility: checkLow(value, values) }}
        >
          &uarr;
        </div>
        <div className="arrowed-list-item">{value}</div>
        <div
          className="arrow-down"
          style={{ visibility: checkHigh(value, values) }}
        >
          &darr;
        </div>
      </div>
    );
  }
}

const checkLow = (value, values) => {
  if (!values) return false;
  return values.findIndex(v => v === value) === 0 ? "hidden" : "visible";
};

const checkHigh = (value, values) => {
  if (!values) return false;
  return values.findIndex(v => v === value) === values.length - 1
    ? "hidden"
    : "visible";
};
